import { FC } from "react";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { AgentAssignmentFilterEnum } from "constants/filters/agent-assignment-filter";

import { IFilterConfig } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

interface IProps {
  filterValues: AgentAssignmentFilterEnum[];
  filterConfig: IFilterConfig;
  onChange(selectedItem: { name: string; value: [string] | null }): void;
  onClose(): void;
}

export const AgentAssignmentFilterLabels = {
  [AgentAssignmentFilterEnum.Assigned]: "Assigned to agent",
  [AgentAssignmentFilterEnum.Unassigned]: "Unassigned",
};

const items = [AgentAssignmentFilterEnum.Assigned, AgentAssignmentFilterEnum.Unassigned].map(value => ({
  key: value,
  name: AgentAssignmentFilterLabels[value],
}));

const AgentAssignmentFilter: FC<IProps> = props => {
  const { onChange, filterValues, onClose } = props;
  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    onChange({ name: Filter.AgentAssignment, value: selectedItem !== null ? [selectedItem[0].key] : null });
    onClose();
  };

  const selected = filterValues?.includes(AgentAssignmentFilterEnum.Assigned) ? [items[0]] : [items[1]];

  return (
    <Picker
      id="agent-assignment-filter"
      hideClearButton
      openedOnInit
      placeholder="Select"
      options={items}
      selected={filterValues ? selected : []}
      onSelect={handleChange}
      searchDisabled
    />
  );
};

export default withFilterBase(AgentAssignmentFilter);
